<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">All Vehicles</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-plus" label="Add Vehicle" iconPos="left" routerLink="/addVehicle"></button>
    </div>
</div>

<div class="p-white shadow m-3">
<p-table [value]="products" [autoLayout]="true" responsiveLayout="scroll" [autoLayout]="true"  styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text"  placeholder="Search keyword" />
            </span>
            <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th  pSortableColumn="code">Numberplate ID<p-sortIcon field="code"></p-sortIcon></th>
            <th  pSortableColumn="model">Vehicle model<p-sortIcon field="code"></p-sortIcon></th>
            <th  pSortableColumn="driver">Driver Name<p-sortIcon field="code"></p-sortIcon></th>
            <th>Driver mobile no</th>
            <th>Fule Type</th>
            <th>Manufactured year</th>
            <th>Registered Year</th>
            <th>Created On <p-columnFilter type="date" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Created By<p-columnFilter type="text" field="CreatedBy" display="menu"></p-columnFilter> </th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
    <td><a (click)="visibleSidebar2 = true" >KL-7997</a></td>
    <td>Alpine A106</td>
    <td>Jesse Stanley</td>
    <td>(079) 2290888</td>
    <td>Electric</td>
    <td>2007</td>
    <td>2014</td>
    <td>09/16/2021</td>
    <td>Ross Carlson</td>


      <!--  <td>
    <p-tag styleClass="me-2 mb-1" value="Primary"></p-tag>
        <p-tag styleClass="me-2 mb-1" severity="success" value="Success"></p-tag>
        <p-tag styleClass="me-2 mb-1" severity="warning" value="Warning"></p-tag>
        <p-tag severity="danger" value="Danger"></p-tag>
    </td>
    <td>
        <div class="d-flex flex-column justify-content-end">
            <div class="d-flex justify-content-end mb-1">
                <small>10/10 Steps</small>
            </div>
            <p-progressBar [value]="10"></p-progressBar>
        </div>
    </td>-->
    <td>
        <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-success p-button-text"></button>
        <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-danger p-button-text"></button>
    </td>
        </tr>
    </ng-template>
</p-table>
<div class="d-flex justify-content-end">
           
    <p-paginator [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,20,30]"></p-paginator>
</div>
</div>

<p-sidebar [(visible)]="visibleSidebar2" position="right" [baseZIndex]="10000">
    <div class="d-flex flex-row align-items-center mb-5">
        <h4 class="my-0">KL-7997</h4>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Vehicle model</b></p>
        <p class="mt-2 mb-0">Alpine A106</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Driver Name</b></p>
        <p class="mt-2 mb-0">Jesse Stanley</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Driver mobile no</b></p>
        <p class="mt-2 mb-0">(079) 2290888</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Fule Type</b></p>
        <p class="mt-2 mb-0">Electric</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Manufactured year</b></p>
        <p class="mt-2 mb-0">2007</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Registered Year</b></p>
        <p class="mt-2 mb-0">2014</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Created On</b></p>
        <p class="mt-2 mb-0">09/16/2021</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Created By</b></p>
        <p class="mt-2 mb-0">Ross Carlson</p>
    </div>
</p-sidebar>

